import { createFileRoute, Link, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { OnboardingSlideForm } from '@/admin/sitecontent/OnboardingSlideForm';
import { OnboardingHeader } from '@/admin/ui/ContentNav';
import { DetailPage } from '@/admin/ui/Editor';
import { PageTitle } from '@/admin/ui/Page';

export const Route = createFileRoute('/admin/onboarding-slides/new')({
  staticData: { minTier: 'ADMIN' },
  validateSearch: (s: Record<string, unknown>) => ({
    onboarding: Number(s.onboarding),
  }),
  component: NewSlide,
});

function NewSlide() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { onboarding } = Route.useSearch();
  const back = () =>
    navigate({ to: '/admin/onboarding-slides/', search: { onboarding } });
  return (
    <DetailPage>
      <OnboardingHeader onboardingId={onboarding} />
      <Link to="/admin/onboarding-slides/" search={{ onboarding }}>
        {t('admin.onboardingSlides.backToSlides')}
      </Link>
      <PageTitle>{t('admin.onboardingSlides.addSlide')}</PageTitle>
      <OnboardingSlideForm
        onboardingId={onboarding}
        onSaved={back}
        onCancel={back}
      />
    </DetailPage>
  );
}
